import {
    DataGridColumn,
    IDataGridColumnValidatorResult,
} from '@/components/DataGrid/DataGridColumn.class';
import { Trip } from '@/typing/api/tripNew.class';
import { DataGridErrorType } from '@/typing/enums/dataGridErrorType.enum';

export default function isSelectionOptionValidator(
    val?: any,
    item?: Trip,
    items?: Trip[],
    column?: DataGridColumn,
): IDataGridColumnValidatorResult {
    const returnValue: IDataGridColumnValidatorResult = {
        hasError: false,
        message: '',
    };

    if (!val || !column) {
        return returnValue;
    }

    if (
        (column.selectOptions && column.selectOptions.length === 0) ||
        !column.selectOptions
    ) {
        return returnValue;
    }

    const values = column.selectOptions.map((o: any) =>
        column.selectOptionValueFn(o)
    );

    returnValue.hasError = !values.includes(val);

    if (returnValue.hasError) {
        returnValue.message = 'is niet bekend, kies een ander';
        returnValue.errorType = DataGridErrorType.Error;
    }

    return returnValue as IDataGridColumnValidatorResult;
}
